const styles = {
  container: {
    gap: "1rem",
    display: "flex",
    flexDirection: "column",
  },
  heading: {
    fontWeight: 600,
    color: "#1B1C1B",
    lineHeight: "2.25rem",
    fontSize: "1.25rem",
  },
  formContainer: { display: "grid", gap: "0.5rem", paddingTop: "1rem" },
  subHeading: {
    fontWeight: 600,
    color: "#334155",
    lineHeight: "2rem",
    fontSize: "1.125rem",
  },

  select_field: {
    borderRadius: "0.75rem",
    color: "#ED0000",
    height: "2.5rem",
  },
  spinner: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  pickerDetailsContainer: {
    marginLeft: "2rem",
    marginRight: "2rem",
    padding: "2rem",
    border: "1px solid",
    borderColor: "#E2E8F0",
    borderRadius: "4px",
  },

  buttonsGrid: {
    paddingTop: "3rem",
  },
  cancelButton: {
    borderColor: "#CBD5E1",
    borderRadius: "small",
    color: "#475569",
    fontWeight: 600,
    lineHeight: "1.5rem",
    fontSize: "0.875rem",
    textTransform: "none",
  },
  saveButton: {
    borderColor: "#006AFF",
    borderRadius: "small",
    fontWeight: 600,
    lineHeight: "1.5rem",
    fontSize: "0.875rem",
    textTransform: "none",
    color: "#FEFEFE",
  },
};

export default styles;
